export default "__VITE_ASSET__Cj$HyVb7__"